var map = {
	"./banjo-and-kazooie-min.png": "ba4b",
	"./bayonetta-min.png": "fdb1",
	"./bowser-jr-min.png": "cfd3",
	"./bowser-min.png": "3987",
	"./byleth-min.png": "2178",
	"./captain-falcon-min.png": "9fc7",
	"./chrom-min.png": "55d1",
	"./cloud-min.png": "ca09",
	"./corrin-min.png": "e277",
	"./daisy-min.png": "59a8",
	"./dark-pit-min.png": "9ea7",
	"./dark-samus-min.png": "0f78",
	"./diddy-kong-min.png": "5a07",
	"./donkey-kong-min.png": "96a8",
	"./dr-mario-min.png": "9422",
	"./duck-hunt-min.png": "e4b1c",
	"./falco-min.png": "e63a",
	"./fox-min.png": "ea22",
	"./ganondorf-min.png": "e6af",
	"./greninja-min.png": "5fe1",
	"./hero-min.png": "5de2",
	"./ice-climbers-min.png": "0286",
	"./ike-min.png": "0169",
	"./incineroar-min.png": "94f2",
	"./inkling-min.png": "89c2",
	"./isabelle-min.png": "06c8",
	"./jigglypuff-min.png": "1e25",
	"./joker-min.png": "49b6",
	"./kazuya-min.png": "2bcf",
	"./ken-min.png": "fc34",
	"./king-dedede-min.png": "8ef9",
	"./king-k-rool-min.png": "4d8b",
	"./kirby-min.png": "c703",
	"./link-min.png": "c9f1",
	"./little-mac-min.png": "8466",
	"./lucario-min.png": "663a",
	"./lucas-min.png": "8f77",
	"./lucina-min.png": "5f10",
	"./luigi-min.png": "a216",
	"./mario-min.png": "61a8",
	"./marth-min.png": "60f1",
	"./mega-man-min.png": "d9c3",
	"./meta-knight-min.png": "d172",
	"./mewtwo-min.png": "e254",
	"./mii-brawler-min.png": "70d6",
	"./mii-gunner-min.png": "cb50",
	"./mii-swordfighter-min.png": "9df2",
	"./min-min-min.png": "5958",
	"./mr-game-and-watch-min.png": "6bd0",
	"./ness-min.png": "b0eb",
	"./olimar-min.png": "0a8d",
	"./pac-man-min.png": "3559",
	"./palutena-min.png": "14af",
	"./peach-min.png": "2925",
	"./pichu-min.png": "1cf8",
	"./pikachu-min.png": "6529",
	"./piranha-plant-min.png": "3e62",
	"./pit-min.png": "4538",
	"./pokemon-trainer-min.png": "db3e",
	"./pyra-and-mythra-min.png": "612b",
	"./richter-min.png": "7e9e",
	"./ridley-min.png": "defb",
	"./rob-min.png": "48bb",
	"./robin-min.png": "268a",
	"./rosalina-and-luma-min.png": "68e4",
	"./roy-min.png": "9314",
	"./ryu-min.png": "d147",
	"./samus-min.png": "d14a",
	"./sephiroth-min.png": "ff21",
	"./sheik-min.png": "1c02",
	"./shulk-min.png": "4646",
	"./simon-min.png": "fc5f",
	"./snake-min.png": "d351",
	"./sonic-min.png": "cf62",
	"./sora-min.png": "ca03",
	"./steve-min.png": "1965",
	"./terry-min.png": "4cf6",
	"./toon-link-min.png": "5fe7",
	"./villager-min.png": "48c8",
	"./wario-min.png": "6fcc",
	"./wii-fit-trainer-min.png": "579c",
	"./wolf-min.png": "f14b",
	"./yoshi-min.png": "93bd",
	"./young-link-min.png": "dc42",
	"./zelda-min.png": "3ea6",
	"./zero-suit-samus-min.png": "6a010"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05a8";